export default __webpack_public_path__ + "static/media/img_default.12c79bc8.png";